import PassportAdminReviewTable from "./PassportAdminReviewTable";

export default PassportAdminReviewTable;
